import AuthService from "@/services/auth";
import forEach from "lodash/forEach";

export default {
  namespaced: true,
  state: {},

  getters: {},

  actions: {
    async getUserData({ commit, state, getters, dispatch }) {
      try {
        const response = await AuthService.getUserData();
        //window.localStorage.setItem('user_data', JSON.stringify(response.data.attributes));
        return response;
      } catch (e) {
        console.log(e);
      }
    },
    async logIn({ commit, state, getters, dispatch }, payload) {

      const response = await AuthService.logIn(payload);

      if (!response.data.success) {
        return response;
      } else {
        let user_attributes = response.data.attributes.user;

        let user_permissions = [];
        user_attributes.roles.filter((role) => {
          forEach(role.permissions, (permission) =>
            user_permissions.push(permission.name)
          );
          delete role.permissions;
          delete role.pivot;
        });

        user_permissions = [...new Set(user_permissions)];
        delete user_attributes.permissions;

        user_attributes.permissions = user_permissions;
        window.localStorage.setItem(
          "access_token",
          response.data.attributes.token
        );
        delete user_attributes.password;
        window.localStorage.setItem(
          "user_data",
          JSON.stringify(user_attributes)
        );
        return response;
      }
    },
    async logInByGoogle({ commit, state, getters, dispatch }, payload) {
      const response = await AuthService.logInByGoogle(payload);

      if (!response.data.success) {
        return response;
      } else {
        let user_attributes = response.data.attributes.user;

        let user_permissions = [];
        user_attributes.roles.filter((role) => {
          forEach(role.permissions, (permission) =>
            user_permissions.push(permission.name)
          );
          delete role.permissions;
          delete role.pivot;
        });

        user_permissions = [...new Set(user_permissions)];
        delete user_attributes.permissions;

        user_attributes.permissions = user_permissions;
        window.localStorage.setItem(
          "access_token",
          response.data.attributes.token
        );
        delete user_attributes.password;
        window.localStorage.setItem(
          "user_data",
          JSON.stringify(user_attributes)
        );
        return response;
      }
    },
    async logOut({ commit, state, getters, dispatch }) {
      await AuthService.logOut();
    },
  },

  mutations: {
    SET_VALUE_FROM_API(state, payload) {
      state.valueFromApi = payload;
    },
  },
};
